import '.a2{position:fixed;}.ssr-plugin'
import '.bv{top:0px;}.ssr-plugin'
import '.bp{left:0px;}.ssr-plugin'
import '.bq{right:0px;}.ssr-plugin'
import '.c7{bottom:0px;}.ssr-plugin'
import '.hb{background-color:rgba(0, 0, 0, 0.25);}.ssr-plugin'
import '.hc{z-index:998;}.ssr-plugin'
import '.hd{transition:opacity 0.3s ease;}.ssr-plugin'
import '.a4{height:100vh;}.ssr-plugin'
import '.a8{width:100%;}.ssr-plugin'
import '.aj{background-color:var(--shades-white);}.ssr-plugin'
import '.he{transition:transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);}.ssr-plugin'
import '.hf{z-index:999;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.a9{justify-content:space-between;}.ssr-plugin'
import '.cp{padding:1.5rem;}.ssr-plugin'
import '.hg{border-bottom:1px solid var(--gray-border);}.ssr-plugin'
import '.b8{flex-shrink:0;}.ssr-plugin'
import '.cb{flex:1;}.ssr-plugin'
import '.bd{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { IconButton } from '@app/components/core/button/IconButton'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { PropsWithChildren } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'

export interface DrawerProps extends PropsWithChildren {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  portal?: HTMLElement
  style?: Style
  side: 'left' | 'right'
}

export const Drawer = ({
  title,
  open,
  setOpen,
  children,
  portal: _portal,
  style,
  side,
}: DrawerProps) => {
  const isMobile = useMediaQuery()

  const translateValue = open ? '0' : side === 'left' ? '-100%' : '100%'

  return (
    <>
      {/* Overlay */}
      <div className="a2 bv bp bq c7 hb hc hd"
        onClick={() => setOpen(false)}
        style={{
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',}}
      />

      {/* Sidebar Panel */}
      <styled.div className="a2 bv a4 a8 aj he hf a e"
        style={{
          [side]: 0,
          maxWidth: isMobile ? '100%' : '30rem',
          borderRadius: isMobile ? 0 : '1.25rem',
          boxShadow: open ? '0 0 15px rgba(0,0,0,0.15)' : 'none',
          transform: `translateX(${translateValue})`,
          ...style,
        }}
      >
        {/* Header */}
        <div className="a f a9 cp hg b8"
        >
          <Title.H4 style={{ margin: 0 }}>{title}</Title.H4>
          <IconButton
            icon={faXmark}
            size="small"
            variant="secondary"
            onClick={() => setOpen(false)}
          />
        </div>

        {/* Content */}
        <div className="cb bd cp"
        >
          {children}
        </div>
      </styled.div>
    </>
  )
}
